import { ConfigState, EmpathyXConfig, URLConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';
import { ConfigGetter } from '../config.interfaces';

export class URLConfigGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.url]: (configState: ConfigState, getters: any): URLConfig => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      return config.url;
    }
  };

}
